
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      version: process.env.APP_VERSION as string,
    };
  },
});
